import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: "28px",
	height: "28px",
	viewBox: "0 0 28 28",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 28,
			height: 28,
			fill: "currentColor",
			fillOpacity: .2,
			rx: 4
		}),
		/* @__PURE__ */ _jsx("g", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			clipPath: "url(#a)",
			children: /* @__PURE__ */ _jsx("path", { d: "M7.3 9.8A1.7 1.7 0 0 1 9 8.2h10a1.7 1.7 0 0 1 1.7 1.6v10a1.7 1.7 0 0 1-1.7 1.7H9a1.7 1.7 0 0 1-1.7-1.7v-10Zm10-3.3v3.3m-6.6-3.3v3.3m-3.4 3.4h13.4m-7.5 3.3h.8m0 0V19" })
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M4 4h20v20H4z"
			})
		}) })
	]
});
export default SvgCalendarIcon;
